import React, {useEffect, useRef, useState} from 'react';
import {Link, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import {useModal} from "../../contexts/ModalContext";
import {useUser} from "../../contexts/UserContext";
import AxiosConfig from "../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../services/BreadcrumbService";
import {useBreadcrumb} from "../../contexts/BreadcrumbContext";
import styles from "../Admin/Admin.module.css";
import FilterHamburgerCustom from "../../components/Filter/FilterHamburgerCustom";
import TitleSecondary from "../../components/Title/TitleSecondary";
import SearchUtilisateur from "../../components/Search/SearchUtilisateur";
import CrmUserHistoryTable from "../../components/Admin/Crm/CrmUserHistoryTable";
import {Field, Form, Formik} from "formik";
import styles_field from "../../components/Field/Field.module.css";
import PaginationBar from "../../components/Pagination/PaginationBar";
import SearchEntreprise from "../../components/Search/SearchEntreprise";
import CrmUserHistoryTableReferent from "../../components/Crm/CrmUserHistoryTableReferent";

function CrmUserHistoryPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {updateDynamicBreadcrumb} = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const [absences, setAbsences] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [utilisateur, setUtilisateur] = useState(null);
    const [entreprise, setEntreprise] = useState(null);
    const [apiRef, setApiRef] = useState(null);
    const [dateDebut, setDateDebut] = useState(null);
    const [dateFin, setDateFin] = useState(null);
    const [crmType, setCrmType] = useState(null);
    const [typesCrm, setTypesCrm] = useState([]);
    const [canalSend, setCanalSend] = useState(null);
    const [page, setPage] = useState(parseInt(queryParams.get("page")) || 1);
    const [totalPage, setTotalPage] = useState(null);
    const [totalResult, setTotalResult] = useState(null);
    const [sortBy, setSortBy] = useState([]);
    const prevSortBy = useRef(sortBy);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getCrmUserHistory = async () => {
        let url = queryParams ? `/crm/user_history?${queryParams.toString()}` : '/crm/user_history';
        try {
            const response = await AxiosConfig.get(url);
            setMyApiData(response.data.myCrmUserHistory);
            setTotalPage(response.data.totalPages);
            setTotalResult(response.data.totalRecords);
        } catch (error) {
            console.error('error', error);
        }
    }

    const getCrmTypes = async () => {
        try {
            const response = await AxiosConfig.get('/crm/types');
            setTypesCrm(response.data.myCrmTypes);
        } catch (error) {
            console.error('error', error);
        }
    }

    const onSortChange = ({ sortBy }) => {
        if (JSON.stringify(sortBy) !== JSON.stringify(prevSortBy.current)) {
            prevSortBy.current = sortBy;
            setSortBy(sortBy);
        }
    };

    const getInitialSortBy = () => {
        const sortBy = [];
        queryParams.getAll('sort_by').forEach((id, index) => {
            sortBy.push({ id, desc: queryParams.getAll('sort_desc')[index] === 'true' });
        });
        return sortBy;
    };

    useEffect(() => {
        (async () => {
            await getCrmUserHistory();
            await getCrmTypes();
        })();
    }, [location.search]);

    useEffect(() => {
        if (sortBy.length > 0) {
            queryParams.delete('sort_by');
            queryParams.delete('sort_desc');
            sortBy.forEach(sort => {
                queryParams.append('sort_by', sort.id);
                queryParams.append('sort_desc', sort.desc);
            });
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [sortBy]);


    useEffect(() => {
        if (utilisateur) {
            queryParams.set('filter_user', utilisateur.id);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [utilisateur]);

    useEffect(() => {
        if (entreprise) {
            queryParams.set('filter_entreprise', entreprise.entrepriseId);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [entreprise]);

    useEffect(() => {
        if (apiRef) {
            queryParams.set('filter_api_id', apiRef);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [apiRef]);

    useEffect(() => {
        if (dateDebut) {
            queryParams.set('filter_start_date', dateDebut);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [dateDebut]);

    useEffect(() => {
        if (dateFin) {
            queryParams.set('filter_end_date', dateFin);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [dateFin]);

    useEffect(() => {
        if (crmType) {
            queryParams.set('filter_crm_type', crmType);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [crmType]);

    useEffect(() => {
        if (canalSend) {
            queryParams.set('filter_canal_send', canalSend);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [canalSend]);

    useEffect(() => {
        if (page) {
            queryParams.set('page', page);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [page]);

    return (
        <div className="content_tab">
            <TitleMain text="Historique CRM"/>

            <div>
                <FilterHamburgerCustom onReinirFilters={() => navigate(`${location.pathname}`)}>
                    <div className={""}>
                        <div className={""}>
                            <TitleSecondary text="Filtres"/>
                        </div>
                        <div className={""}>
                            <div className={styles_field.field} style={{
                                display: "flex",
                                flexDirection: "row",
                                marginTop: "10px",
                                gap: "10px",
                                justifyContent: "flex-start",
                                alignItems: "center"
                            }}>
                                <span>Du </span>
                                <input type={"date"} onChange={(e) => {
                                    setDateDebut(e.target.value);
                                }}/>

                                <span> au </span>
                                <input type={"date"} onChange={(e) => {
                                    setDateFin(e.target.value);
                                }}/>
                            </div>

                            <div className={styles_field.field}>
                                <span>Utilisateur</span>
                                <SearchUtilisateur onSubmit={(u) => setUtilisateur(u)}/>
                            </div>

                            <div>
                                <Formik initialValues={{"crm_type": ""}} enableReinitialize
                                        onSubmit={() => console.warn("submit")}>
                                    {({isSubmitting, setFieldValue}) => {
                                        return (
                                            <Form className={styles.form}>
                                                <div className={styles_field.select}>
                                                    <span>Type CRM</span>
                                                    <Field as="select" name="type" onChange={(e) => {
                                                        setCrmType(e.target.value);
                                                    }}>
                                                        <option>
                                                            -- Sélectionnez un type de crm --
                                                        </option>
                                                        {typesCrm.map((type, index) => (
                                                            <option key={index} value={type.id.toString()}>
                                                                {type.label}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                </div>
                                            </Form>
                                        );
                                    }}
                                </Formik>
                            </div>

                            <div>
                                <Formik initialValues={{"canal_send": ""}} enableReinitialize
                                        onSubmit={() => console.warn("Coucou")}>
                                    {({isSubmitting, setFieldValue}) => {
                                        return (
                                            <Form className={styles.form}>
                                                <div className={styles_field.select}>
                                                    <span>Canal</span>
                                                    <Field as="select" name="canal" onChange={(e) => {
                                                        setCanalSend(e.target.value);
                                                    }}>
                                                        <option>
                                                            -- Sélectionnez un canal --
                                                        </option>

                                                        <option value={"sms"}>
                                                            SMS
                                                        </option>

                                                        <option value={"email"}>
                                                            Email
                                                        </option>
                                                    </Field>
                                                </div>
                                            </Form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </FilterHamburgerCustom>
            </div>

            {myApiData && <>
                <CrmUserHistoryTableReferent crmUserHistory={myApiData} serverSideSorting={true} onSortChange={onSortChange} initialSortBy={getInitialSortBy()} />
                <PaginationBar page={page} totalPage={totalPage} setPage={setPage} totalResult={totalResult} />
            </>}

        </div>
    )
}

export default CrmUserHistoryPage;
